/**
 * Slate draws an applied filter as a solid dark fill. The design calls for an
 * outlined treatment instead — white fill, dark border, dark label — so these
 * pierce the four CSS variables Slate's `.fs-filter--applied` rule sets.
 *
 * `--slate-color-action-*` resolves on the chip, not on `:root`, so these stay
 * as `var()` references rather than literal hex. Unlayered utilities beat
 * Slate's `@layer components`, so no `!important` is needed. Applied chips
 * therefore hold one constant appearance, including on hover.
 *
 * Pass to a `SlateStyleOverride` wrapping the chips.
 */
export const APPLIED_CHIP_OUTLINE = [
  "[&_.fs-filter--applied]:[--fs-filter-background-color:var(--slate-color-action-surface-inverse)]",
  "[&_.fs-filter--applied]:[--fs-filter-border-color:var(--slate-color-action-text-default)]",
  "[&_.fs-filter--applied]:[--fs-filter-text-color:var(--slate-color-action-text-default)]",
  "[&_.fs-filter--applied]:[--fs-filter-icon-color:var(--slate-color-action-icon-default)]",
  // Dropdown chips opt out of Slate's `applied` to keep their chevron, so they
  // are marked here instead and get the same treatment.
  "[&_[data-filter-applied=true]_.fs-filter]:[--fs-filter-background-color:var(--slate-color-action-surface-inverse)]",
  "[&_[data-filter-applied=true]_.fs-filter]:[--fs-filter-border-color:var(--slate-color-action-text-default)]",
  "[&_[data-filter-applied=true]_.fs-filter]:[--fs-filter-text-color:var(--slate-color-action-text-default)]",
  "[&_[data-filter-applied=true]_.fs-filter]:[--fs-filter-icon-color:var(--slate-color-action-icon-default)]",
].join(" ");
